// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#darklayer{position:fixed;top:0;left:0;width:100%;height:100%;transition:all .2s;z-index:99}#darklayer.active{background-color:rgba(0,0,0,.6)}", ""]);
// Exports
module.exports = exports;
